module.exports = __webpack_public_path__ + "img/v2wallPaper3.fb975bfe.png";